module.exports = __webpack_public_path__ + "img/he8.b6c8df22.png";